var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"no-data-text":"Nebyl nalezen žádný výsledek","hide-default-footer":""},scopedSlots:_vm._u([{key:"item.fullOrientationalNumber",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.orientationalNumber)+_vm._s(item.orientationalNumberLetter)+" ")]}},{key:"item.detail",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"to":{ name: 'addressDetail', params: { id: item.admCode } },"color":"indigo accent-2","dark":"","exact":""}},[_vm._v(" Detail ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }